import { Article } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import AuthService from '../../services/auth.service';

import { dateHeader, formatCellDate } from './timeModeCell';
import { AppPermissions } from '../../constants/Permissions';

import { ProcessStatus } from '../../types/ProcessStatus';

export const makeScanSessionListColumn = (onInfoClick) => {
  const col = [
    {
      header: 'Id',
      accessorKey: 'scanSessionId',
      headerClassName: 'react-table-header-align-center',
      enableColumnFilter: true,
      size: 50,
      style: { textAlign: 'center' },
      cell: ({ row }) =>
        AuthService.hasPermission(AppPermissions.ReaderReport.Read) ? (
          <Tooltip title='Show scan report' placement='right' style={{ cursor: 'pointer' }}>
            <Article style={{ height: '0.7em' }} color='action' cursor='pointer' onClick={(e) => onInfoClick(e, row.original.scanSessionId)} />
          </Tooltip>
        ) : null,
    },
    {
      header: 'Imei',
      accessorKey: 'imei',
      enableColumnFilter: true,
      size: 300,
    },
    {
      header: 'Station',
      accessorKey: 'stationIataCode',
      enableColumnFilter: true,
      size: 55,
    },
    {
      header: 'Facility',
      accessorKey: 'facilityName',
      enableColumnFilter: true,
      size: 150,
    },
    {
      header: dateHeader('Started'),
      accessorKey: 'startDateTime',
      size: 100,
      cell: ({ row, table }) => formatCellDate(table, row.original.startDateTime),
    },
    {
      header: dateHeader('Ended'),
      accessorKey: 'endDateTime',
      enableColumnFilter: false,
      size: 100,
      cell: ({ row, table }) => formatCellDate(table, row.original.endDateTime),
    },
    {
      header: 'Duration',
      accessorKey: 'duration',
      enableColumnFilter: false,
      size: 175,
    },

    ...(AuthService.hasPermission(AppPermissions.ReaderReport.Manage)
      ? [
          {
            header: 'Scanned',
            accessorKey: 'totalScanned',
            size: 65,
            style: { textAlign: 'right' },
          },
          {
            header: 'Received',
            accessorKey: 'totalReceived',
            size: 65,
            style: { textAlign: 'right' },
          },
          {
            header: 'Unique devices',
            accessorKey: 'uniqueDevices',
            size: 100,
            style: { textAlign: 'right' },
          },
        ]
      : []),
    {
      header: 'Process Status',
      accessorKey: 'processStatus',
      size: 50,
      cell: ({ row }) => {
        const status = row.original.processStatus;

        const className =
          status === ProcessStatus.Error
            ? 'text-red'
            : status === ProcessStatus.Processed
              ? 'text-green'
              : status === ProcessStatus.Pending
                ? 'text-yellow'
                : '';

        return <span className={className}>{ProcessStatus[status]}</span>;
      },
    },
    {
      header: 'User',
      accessorKey: 'user.fullName',
      sortable: false,
      enableColumnFilter: true,
      size: 150,
      cell: ({ row }) => (
        <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{row.original.user?.email || 'No email available'}</span>}>
          <span>{row.original.user?.fullName || 'No name available'}</span>
        </Tooltip>
      ),
    },
  ] as Array<any>;

  return col;
};
